import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { getValueInUserLanguage } from '@/core/languageContent';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { CmsPage, cmsPageUserTypes, useCmsPage } from '@/modules/cms_page/CmsPage';
import { dateTime } from '@/core/date';


export default /*@__PURE__*/_defineComponent({
  __name: 'CmsPageIndex',
  setup(__props) {

const { $gettext } = useGettext();
const resource = useCmsPage();
const cmsPageToDelete = ref<CmsPage>();
const deleteName = () => {
	if (!cmsPageToDelete.value) {
		return '';
	}

	return getValueInUserLanguage(cmsPageToDelete.value?.content, 'headline');
};

const columns = [
	new Column<CmsPage>($gettext('Namn'), 'content', 'headline', '+')
		.withFormatter(row => getValueInUserLanguage(row.content, 'headline') as string),
	new Column<CmsPage>($gettext('Publik'), 'user_type')
		.withFormatter(row => row.user_type.map(ut => cmsPageUserTypes[ut]).join(', ')),
	new Column<CmsPage>($gettext('Skapad'), 'created_time', 'created_time')
		.withFormatter(row => dateTime(row.created_time)),
	new ActionColumn<CmsPage>()
		.withEditLink((tc) => ({ name: 'cmsPage.edit', params: { id: tc.id } }))
		.withDeleteLink((tc: CmsPage) => {
			cmsPageToDelete.value = tc;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('CMS-sidor')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'cmsPage.create'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ny CMS-sida ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "delete-title": _unref($gettext)('Ta bort CMS-sida'),
          "delete-name-key": deleteName,
          "to-delete": cmsPageToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((cmsPageToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})